






























import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import HpTitle from "@/components/infrastructures/atoms/text/HpTitle.vue";
import HpText from "@/components/infrastructures/atoms/text/HpText.vue";
import authService from "@/components/domains/authorization/authService";
import PasswordlessService, {
  errorMessage,
  takeFragmentToken
} from "@/components/domains/account/passwordless/passwordlessService";

const NO_TOKEN = "このリンクは使えません。もう一度ログイン用のメールを送ってください。";

/**
 * メールのログイン用リンクの着地ページ（/login/magic-link#token=…）。
 * 開いただけではログインしない（メールソフトが事前にリンクを開くことがあるため）。「ログインする」で使う。
 */
@Component({
  components: {DefaultTemplate, PrimaryBtn, HpTitle, HpText}
})
export default class MagicLinkLandingPage extends Vue {
  name = "MagicLinkLandingPage";

  token = "";
  phase: "ready" | "working" | "failed" = "ready";
  errorMsg = "";

  mounted() {
    this.readToken();
    window.addEventListener("hashchange", this.readToken);
  }

  beforeDestroy() {
    window.removeEventListener("hashchange", this.readToken);
  }

  readToken() {
    const next = takeFragmentToken();
    if (next) {
      // 同じタブで別のリンクを開いたとき（# だけが変わる）もここで拾い直す。
      this.token = next;
      this.errorMsg = "";
      this.phase = "ready";
    } else if (!this.token) {
      this.errorMsg = NO_TOKEN;
      this.phase = "failed";
    }
  }

  async login() {
    if (!this.token || this.phase === "working") {
      return;
    }
    this.phase = "working";
    try {
      await PasswordlessService.verifyMagicLink(this.token);
    } catch (e) {
      // 使い終わったか無効なので、もう一度押させない。
      this.token = "";
      this.errorMsg = errorMessage(e, NO_TOKEN);
      this.phase = "failed";
      return;
    }
    // 通常のログインと同じ後処理（/auth/me → store → 更新タイマー）と行き先。
    await authService.authMe();
    this.$router.push("/mypage");
  }
}
